import { useEffect } from "react";
import { useLocation } from "react-router";

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // SPA route changes don't reset scroll like full page loads do. Without
    // this, navigating from a long page (e.g. /built-near-you/3444) to
    // /quote keeps the previous scroll offset, so /quote opens halfway down.
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);
  return null;
}
